<template>
  <div v-if="provider">
    <v-card
      class="pa-0 bg-primary"
      border
    >
      <v-card-text>
        <div class="d-flex align-start">
          <div class="pr-2">
            <v-icon
              class="c-white"
              icon="info"
            />
          </div>
          <div>
            <h4 class="pb-3 c-white">
              {{ $bct(referredProgramHeader) }}
            </h4>
            <div class="fs-16 fw-normal c-white">
              {{ $bct(referredProgramMessage) }}
            </div>
          </div>
        </div>

        <div class="d-flex w-full justify-center pt-4">
          <v-btn
            v-if="providerProgram"
            @click="handleConfirmProgram"
            class="focus-very-visible"
            color="white"
            size="x-large"
          >
            {{ $bct('Confirm') }}
          </v-btn>
        </div>
      </v-card-text>

      <v-card class="mx-3 my-3 partial-opacity">
        <v-card-text>
          <v-row class="d-flex align-start">
            <v-col>
              <div class="c-black">
                <v-row
                  class="ma-0 pa-0 d-flex align-center"
                  dense
                >
                  <v-col cols="11">
                    <h4
                      class="c-black fw-600 fs-20"
                      data-cy="selection-name"
                      tabindex="0"
                      dense
                    >
                      {{ provider.name }}
                    </h4>

                    <div
                      v-if="provider.license_business_name != provider.name"
                      class="fs-16"
                    >
                      {{ provider.license_business_name }}
                    </div>
                  </v-col>
                </v-row>

                <v-row
                  class="ma-0 pa-0"
                  dense
                >
                  <v-col>
                    <span
                      class="fs-16 fw-400 me-1"
                      tabindex="0"
                    >
                      {{ providerAddress }}
                    </span>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>

          <template v-if="provider.public_notice">
            <v-row class="bg-primary mb-0 c-white">
              <v-col>
                <span class="fs-14 px-8">
                  {{ $bct(provider.public_notice) }}
                </span>
              </v-col>
            </v-row>
          </template>
        </v-card-text>

        <template v-if="!hideViewMore">
          <v-card-actions class="bt-1 pt-2 pb-2 px-4 bc-extra-light-grey pointer">
            <v-btn
              @click="$emit('open')"
              append-icon="chevron_right"
              class="focus-very-visible"
              color="primary"
              variant="text"
              block
            >
              {{ $bct('View more information') }}
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-card>
  </div>
</template>

<script setup>
import { formatAddress } from '@/shared/services/address';

const referredProgramHeader =
  'We’ve identified that you accessed this application using a unique link provided by a preschool provider.';
const referredProgramMessage =
  "The preschool provider sent you this link because you either have a current child already enrolled at this location, or a family member works at this location. If you'd like to be prioritized at this location, please confirm that this is true. This location will automatically become selected and added to your application as your first choice.";

const props = defineProps({
  hideViewMore: Boolean,
  provider: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['confirm', 'open']);

const $bct = inject('translator');

const providerAddress = computed(() => {
  if (!props.provider) return null;
  return formatAddress(props.provider.address1, props.provider.city, props.provider.zip);
});

const providerProgram = computed(() => {
  return props.provider?.programs?.[0];
});

function handleConfirmProgram() {
  return emit('confirm', providerProgram.value.id);
}
</script>

<style>
.partial-opacity {
  opacity: 0.8;
}
</style>
